import Modal from 'react-bootstrap/Modal';
import Slider from "react-slick";
import "../Modal/Modal.css";

const ListingModal = ({ show, onHide, post }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        lazyLoad: true
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    };

    const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton className="border-0 d-flex align-items-start">
                <Modal.Title className="fs-4 fw-bold pe-4" style={{ wordBreak: 'break-word' }}>
                    {post.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4">
                <div className="modal-image-container mb-4">
                    {post.images && post.images.length > 0 && (
                        <Slider {...settings}>
                            {post.images.map((image, index) => (
                                <div key={index} className="modal-image-wrapper">
                                    <img
                                        className="modal-image"
                                        src={`data:${image.contentType};base64,${arrayBufferToBase64(image.data.data)}`}
                                        alt={`apartment ${index + 1}`}
                                    />
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>

                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="info-section">
                            <h5 className="section-title">
                                <i className="fas fa-map-marker-alt text-primary me-2"></i>
                                Location
                            </h5>
                            <p className="mb-0">{post.address}, {post.city}</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="info-section">
                            <h5 className="section-title">
                                <i className="fas fa-phone text-primary me-2"></i>
                                Contact
                            </h5>
                            <p className="mb-0">{post.contact}</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="info-section">
                            <h5 className="section-title">
                                <i className="fas fa-dollar-sign text-primary me-2"></i>
                                Rent
                            </h5>
                            <p className="mb-0">${post.rent}</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="info-section">
                            <h5 className="section-title">
                                <i className="fas fa-calendar text-primary me-2"></i>
                                Availability
                            </h5>
                            <p className="mb-0">{formatDate(post.startDate)} to {formatDate(post.endDate)}</p>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="info-section">
                            <h5 className="section-title">
                                <i className="fas fa-home text-primary me-2"></i>
                                Property Details
                            </h5>
                            <p className="mb-0">
                                Subleasing {post.subleaseRooms} room(s) in a {post.totalBedrooms} bed/{post.totalBathrooms} bath apartment
                            </p>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="info-section">
                            <h5 className="section-title">
                                <i className="fas fa-user text-primary me-2"></i>
                                Preferences
                            </h5>
                            <p className="mb-0">{post.preferences}</p>
                        </div>
                    </div>

                    {post.description && (
                        <div className="col-12">
                            <div className="info-section">
                                <h5 className="section-title">
                                    <i className="fas fa-info-circle text-primary me-2"></i>
                                    Additional Information
                                </h5>
                                <p className="mb-0">{post.description}</p>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ListingModal; 